<template>
  <div
    class="container d-flex align-items-center justify-content-center error-page"
  >
    <div class="text-center">
      <img
        src="/assets/images/djsaturn-logo.svg"
        alt="DJ Saturn"
        class="img-fluid error-logo mb-4"
      />

      <div class="error-code fw-bold">404</div>

      <h1 class="h2 fw-bold mb-3">Looks like this track doesn't exist.</h1>

      <p class="text-white-50 fs-5 mb-4">
        The page you're looking for may have moved, been removed, or never made
        it into the mix.
      </p>

      <div class="d-flex flex-column flex-sm-row gap-3 justify-content-center">
        <router-link to="/" class="btn btn-light fw-bold px-4 py-2">
          <i class="bi bi-house-door-fill me-2"></i>
          Back Home
        </router-link>

        <router-link
          to="/links"
          class="btn btn-outline-light fw-bold px-4 py-2"
        >
          <i class="bi bi-link-45deg me-2"></i>
          DJ Saturn Links
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.error-page {
  min-height: calc(100vh - 100px);
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.error-logo {
  width: 100%;
  max-width: 320px;
}

.error-code {
  font-size: clamp(5rem, 15vw, 9rem);
  line-height: 0.9;
  letter-spacing: -0.05em;
  opacity: 0.15;
  margin-bottom: 1.5rem;
}

.error-page p {
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
}

.error-page .btn {
  min-width: 180px;
  border-radius: 0.6rem;
}

@media (max-width: 575.98px) {
  .error-logo {
    max-width: 250px;
  }

  .error-page {
    min-height: calc(100vh - 70px);
  }

  .error-page .btn {
    width: 100%;
  }
}
</style>
